import React from 'react';
import { PriceBlock } from './PriceBlock';
import { PRICE_NOW } from './salesData';
const COMPARISON = [{
  option: 'Community manager',
  cost: 'Gasto mensual recurrente'
}, {
  option: 'Agencia',
  cost: 'Inversión mensual'
}, {
  option: 'Cursos',
  cost: 'Muchas horas de formación'
}];
export function OfferSection() {
  return <section id="comprar" className="bg-cream py-12 sm:py-16" data-id="element-144" data-mp="dfq0isi8o5i4">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-145" data-mp="idrjzejku6u4">
        <h2 className="font-display text-2xl font-black leading-tight text-ink sm:text-4xl" data-id="element-146" data-mp="ifazv41bmfvd">
          Todo el sistema, un solo pago
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm text-ink/70 sm:text-base" data-id="element-147" data-mp="rdn1e13q6y2l">
          6 sistemas complementarios en PDF, más los bonos incluidos en la oferta.
        </p>

        <ul className="mx-auto mt-7 max-w-md space-y-2 text-left" data-id="element-148" data-mp="2t5j9t1uljrt5">
          {COMPARISON.map(c => <li key={c.option} className="flex items-center justify-between gap-3 rounded-xl border border-rose/10 bg-white px-4 py-3 text-sm shadow-sm" data-id="element-149" data-mp="2y448uxy445g0">
              <span className="font-semibold text-ink" data-id="element-150" data-mp="xx1yzyzvcm62">{c.option}</span>
              <span className="text-right text-ink/60" data-id="element-151" data-mp="xup7ov880zgc">{c.cost}</span>
            </li>)}
          <li className="flex items-center justify-between gap-3 rounded-xl border-2 border-rose/30 bg-white px-4 py-3 text-sm shadow-sm" data-id="element-152" data-mp="svmdy6xoyfno">
            <span className="font-semibold text-rose-deep" data-id="element-153" data-mp="1lmw9i9wptyn5">Estética Digital PRO</span>
            <span className="text-right font-sans font-bold text-ink tabular-nums" data-id="element-154" data-mp="1gnjciwc4rb6u">
              Pago único de {PRICE_NOW}
            </span>
          </li>
        </ul>

        <p className="mx-auto mt-4 max-w-xl text-[0.78rem] leading-relaxed text-ink/55" data-id="element-155" data-mp="1cnsov1hwhb6j">
          Está pensado para la profesional que hoy gestiona personalmente sus redes y necesita un
          sistema práctico para hacerlo mejor.
        </p>

        <PriceBlock className="mt-6" data-id="element-156" data-mp="3sckmp59by8zb" />
      </div>
    </section>;
}